(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/active-games.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/active-games.js');
'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  hooks
} = svs.arena.shared;
const {
  ErrorMessage
} = svs.arena.shared.components;
const {
  ActiveGame,
  NoActiveGame
} = svs.arena.pages.teams.components;
const {
  ListGroup
} = svs.ui.ReactListGroup;
const ActiveGames = _ref => {
  var _wagerData$wagers, _wagerData$wagers2, _wagerData$wagers3;
  let {
    teamId
  } = _ref;
  const {
    wagerData,
    isLoading,
    error
  } = hooks.useWagers(teamId);
  const [isShowAllWagers, setIsShowAllWagers] = React.useState(false);
  const displayWagers = isShowAllWagers ? wagerData === null || wagerData === void 0 ? void 0 : wagerData.wagers : wagerData === null || wagerData === void 0 || (_wagerData$wagers = wagerData.wagers) === null || _wagerData$wagers === void 0 ? void 0 : _wagerData$wagers.slice(0, 3);
  if (error) {
    return React.createElement(ErrorMessage, {
      header: "Tillf\xE4lligt fel!",
      icon: "exclamation-sign",
      text: "N\xE5gonting gick fel n\xE4r p\xE5g\xE5ende spel skulle visas upp. F\xF6rs\xF6k igen om en stund."
    });
  }
  return React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "h4 margin-bottom-1 margin-top-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " P\xE5g\xE5ende spel ")), isLoading && React.createElement("div", {
    className: "padding-1 u-border-bottom-1 border-grey-300 margin-top-0 override"
  }, "Laddar in era spel..."), !isLoading && wagerData && wagerData.wagers && React.createElement(ListGroup, null, displayWagers === null || displayWagers === void 0 ? void 0 : displayWagers.map(wager => React.createElement(ActiveGame, {
    key: wager.wagerId,
    wager: wager
  }))), !isLoading && (wagerData === null || wagerData === void 0 || (_wagerData$wagers2 = wagerData.wagers) === null || _wagerData$wagers2 === void 0 ? void 0 : _wagerData$wagers2.length) > 3 && !isShowAllWagers && React.createElement("div", {
    className: "u-text-center margin"
  }, React.createElement(Button, {
    onClick: () => setIsShowAllWagers(true),
    size: 100,
    transparent: true
  }, "Visa alla p\xE5g\xE5ende spel")), !isLoading && (wagerData === null || wagerData === void 0 || (_wagerData$wagers3 = wagerData.wagers) === null || _wagerData$wagers3 === void 0 ? void 0 : _wagerData$wagers3.length) === 0 && React.createElement(NoActiveGame, null));
};
svs.arena.pages.teams.components.ActiveGames = ActiveGames;

 })(window);